import { render } from "./EditHistoricModal.vue?vue&type=template&id=0673fdce"
import script from "./EditHistoricModal.vue?vue&type=script&lang=js"
export * from "./EditHistoricModal.vue?vue&type=script&lang=js"

import "./EditHistoricModal.vue?vue&type=style&index=0&id=0673fdce&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__